const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}



// Codex: move localization selector from header to footer
function moveLocalizationToFooter() {
  const headerLoc = document.querySelector('.desktop-localization-wrapper');
  const footerSlot = document.querySelector('.footer__localization');
  if (!headerLoc || !footerSlot) return;
  if (footerSlot.querySelector('.desktop-localization-wrapper')) return;
  footerSlot.appendChild(headerLoc);
}

document.addEventListener('DOMContentLoaded', moveLocalizationToFooter);
document.addEventListener('shopify:section:load', moveLocalizationToFooter);
window.addEventListener('load', moveLocalizationToFooter);
setTimeout(moveLocalizationToFooter, 600);



function removeHomeNavLinks() {
  document.querySelectorAll('.header__inline-menu a[href="/"], .menu-drawer__menu-item[href="/"]').forEach((link) => {
    const item = link.closest('li') || link;
    item.style.display = 'none';
  });
}

document.addEventListener('DOMContentLoaded', removeHomeNavLinks);
document.addEventListener('shopify:section:load', removeHomeNavLinks);
window.addEventListener('load', removeHomeNavLinks);
setTimeout(removeHomeNavLinks, 600);

function speedUpAccountLink() {
  document.querySelectorAll('a[href*="/customer_authentication/redirect"]').forEach((link) => {
    const currentHref = link.getAttribute('href');
    if (!currentHref) return;
    link.setAttribute('href', currentHref.replace('/customer_authentication/redirect', '/customer_authentication/login'));
  });
}

document.addEventListener('DOMContentLoaded', speedUpAccountLink);
document.addEventListener('shopify:section:load', speedUpAccountLink);
window.addEventListener('load', speedUpAccountLink);
setTimeout(speedUpAccountLink, 600);


function cleanupHeaderMenuAndLocalization() {
  document.querySelectorAll('.header__inline-menu a, .menu-drawer__menu-item, .list-menu__item').forEach((link) => {
    const text = (link.textContent || '').trim();
    const href = link.getAttribute('href') || '';
    if (text === 'Home' || href === '/') {
      const item = link.closest('li') || link;
      item.style.display = 'none';
    }
  });

  const headerLoc = document.querySelector('.desktop-localization-wrapper');
  const footerTarget = document.querySelector('.footer__content-top, footer .footer__content-bottom, footer .footer');
  if (headerLoc && footerTarget && !footerTarget.contains(headerLoc)) {
    footerTarget.appendChild(headerLoc);
  }

  const headerForm = document.querySelector('header localization-form, .header localization-form, header .localization-form');
  if (headerForm && !headerForm.closest('footer')) {
    headerForm.style.display = 'none';
  }
}

const rerunHeaderCleanup = () => cleanupHeaderMenuAndLocalization();
document.addEventListener('DOMContentLoaded', rerunHeaderCleanup);
document.addEventListener('shopify:section:load', rerunHeaderCleanup);
window.addEventListener('load', rerunHeaderCleanup);
setTimeout(rerunHeaderCleanup, 300);
setTimeout(rerunHeaderCleanup, 1200);

function restoreHeaderIcons() {
  document.querySelectorAll('.header__icons, .header__icons--localization, .header-localization').forEach((group) => {
    group.style.display = 'flex';
    group.style.visibility = 'visible';
    group.style.opacity = '1';
  });
}

document.addEventListener('DOMContentLoaded', restoreHeaderIcons);
document.addEventListener('shopify:section:load', restoreHeaderIcons);
window.addEventListener('load', restoreHeaderIcons);
setTimeout(restoreHeaderIcons, 300);
setTimeout(restoreHeaderIcons, 1200);

function enforceDesktopHeaderIcons() {
  let styleTag = document.getElementById('aku-header-icons-fix');
  if (!styleTag) {
    styleTag = document.createElement('style');
    styleTag.id = 'aku-header-icons-fix';
    document.head.appendChild(styleTag);
  }
  styleTag.textContent = '@media screen and (min-width: 990px) {' +
    '.header { position: relative; }' +
    '.header__icons.header__icons--localization.header-localization { display: flex !important; align-items: center !important; justify-content: flex-end !important; gap: 0 !important; position: absolute !important; right: 0 !important; top: 50% !important; transform: translateY(-50%) !important; width: auto !important; opacity: 1 !important; visibility: visible !important; }' +
    '.header__icons .desktop-localization-wrapper, .header__icons localization-form, .header__icons .localization-form { display: none !important; }' +
    '}';
}

document.addEventListener('DOMContentLoaded', enforceDesktopHeaderIcons);
document.addEventListener('shopify:section:load', enforceDesktopHeaderIcons);
window.addEventListener('load', enforceDesktopHeaderIcons);
setTimeout(enforceDesktopHeaderIcons, 300);
setTimeout(enforceDesktopHeaderIcons, 1200);
function normalizeDesktopHeaderIcons() {
  let styleTag = document.getElementById('aku-header-icons-fix');
  if (!styleTag) {
    styleTag = document.createElement('style');
    styleTag.id = 'aku-header-icons-fix';
    document.head.appendChild(styleTag);
  }
  styleTag.textContent = "@media screen and (min-width: 990px) { .header__icons.header__icons--localization.header-localization { display: flex !important; align-items: center !important; justify-self: end !important; justify-content: flex-end !important; position: static !important; right: auto !important; top: auto !important; transform: none !important; width: auto !important; opacity: 1 !important; visibility: visible !important; } .header__icons .desktop-localization-wrapper, .header__icons localization-form, .header__icons .localization-form { display: none !important; } .header__search details { position: static !important; } .search-modal { right: 0 !important; left: auto !important; } }";
}

document.addEventListener('DOMContentLoaded', normalizeDesktopHeaderIcons);
document.addEventListener('shopify:section:load', normalizeDesktopHeaderIcons);
window.addEventListener('load', normalizeDesktopHeaderIcons);
setTimeout(normalizeDesktopHeaderIcons, 300);
setTimeout(normalizeDesktopHeaderIcons, 1200);
function keepHeaderIconsVisibleOnly() {
  let styleTag = document.getElementById('aku-header-icons-fix');
  if (!styleTag) {
    styleTag = document.createElement('style');
    styleTag.id = 'aku-header-icons-fix';
    document.head.appendChild(styleTag);
  }
  styleTag.textContent = '@media screen and (min-width: 990px) { .header__icons.header__icons--localization.header-localization { display: flex !important; align-items: center !important; justify-self: end !important; justify-content: flex-end !important; position: static !important; right: auto !important; top: auto !important; transform: none !important; width: auto !important; opacity: 1 !important; visibility: visible !important; } .header__icons .desktop-localization-wrapper, .header__icons localization-form, .header__icons .localization-form { display: none !important; } }';
}

document.addEventListener('DOMContentLoaded', keepHeaderIconsVisibleOnly);
document.addEventListener('shopify:section:load', keepHeaderIconsVisibleOnly);
window.addEventListener('load', keepHeaderIconsVisibleOnly);
setTimeout(keepHeaderIconsVisibleOnly, 300);
setTimeout(keepHeaderIconsVisibleOnly, 1200);

function keepSearchProductOnly() {
  document.querySelectorAll('form[action="/search"]').forEach((form) => {
    let typeInput = form.querySelector('input[name="type"]');
    if (!typeInput) {
      typeInput = document.createElement('input');
      typeInput.type = 'hidden';
      typeInput.name = 'type';
      form.appendChild(typeInput);
    }
    typeInput.value = 'product';
  });

  const hideNonProductSearchResults = () => {
    const nonProductPatterns = ['/blogs/', '/pages/', '/articles/'];

    document.querySelectorAll('[data-predictive-search] li, [data-predictive-search] .predictive-search__result-group, .template-search li, .search-results li').forEach((item) => {
      const hrefs = Array.from(item.querySelectorAll('a[href]')).map((link) => link.getAttribute('href') || '');
      const hasProductLink = hrefs.some((href) => href.includes('/products/'));
      const hasNonProductLink = hrefs.some((href) => nonProductPatterns.some((pattern) => href.includes(pattern)));
      if (hasNonProductLink && !hasProductLink) {
        item.style.display = 'none';
      }
    });

    document.querySelectorAll('[id*="predictive-search-articles"], [id*="predictive-search-pages"], [id*="predictive-search-queries"]').forEach((section) => {
      section.style.display = 'none';
    });

    document.querySelectorAll('.predictive-search__heading').forEach((heading) => {
      const text = (heading.textContent || '').trim().toLowerCase();
      if (text.includes('articles') || text.includes('pages') || text.includes('queries') || text.includes('posts') || text.includes('blogs')) {
        heading.style.display = 'none';
      }
    });
  };

  hideNonProductSearchResults();

  if (!window.__akuSearchProductsOnlyObserver) {
    window.__akuSearchProductsOnlyObserver = new MutationObserver(hideNonProductSearchResults);
    window.__akuSearchProductsOnlyObserver.observe(document.body, { childList: true, subtree: true });
  }
}

document.addEventListener('DOMContentLoaded', keepSearchProductOnly);
document.addEventListener('shopify:section:load', keepSearchProductOnly);
window.addEventListener('load', keepSearchProductOnly);
setTimeout(keepSearchProductOnly, 300);
setTimeout(keepSearchProductOnly, 1200);
function enhanceHomepageMediaAndFooter() {
  let styleTag = document.getElementById('aku-home-footer-layout-fix');
  if (!styleTag) {
    styleTag = document.createElement('style');
    styleTag.id = 'aku-home-footer-layout-fix';
    document.head.appendChild(styleTag);
  }
  styleTag.textContent = ".footer__payment,.list-payment{display:flex !important;justify-content:center !important;align-items:center !important;text-align:center !important;} .list-payment{flex-wrap:wrap;gap:.8rem;width:100%;padding-left:0;} .footer__list-social{display:flex !important;justify-content:center !important;width:100% !important;padding-left:0 !important;} .aku-media-slider-wrap{position:relative;padding:0 56px;} .aku-media-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:3;width:42px;height:42px;border-radius:999px;border:1px solid rgba(255,255,255,.28);background:rgba(18,18,18,.78);color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:opacity .2s ease,background .2s ease;} .aku-media-arrow:hover{background:rgba(18,18,18,.92);} .aku-media-arrow[hidden],.aku-media-arrow[disabled]{display:none !important;} .aku-media-arrow--prev{left:6px;} .aku-media-arrow--next{right:6px;} @media screen and (max-width: 749px){.aku-media-slider-wrap{padding:0 42px;}.aku-media-arrow{width:36px;height:36px;}.aku-media-arrow--prev{left:2px;}.aku-media-arrow--next{right:2px;}} @media screen and (min-width: 990px){.footer__content-top.page-width{display:grid !important;grid-template-columns:minmax(0,1fr) auto !important;align-items:start !important;column-gap:2rem !important;}.footer-block--newsletter{grid-column:1 !important;display:flex !important;flex-direction:column !important;align-items:flex-start !important;}footer .desktop-localization-wrapper{grid-column:2 !important;justify-self:end !important;align-self:start !important;margin-top:0 !important;}.footer__list-social{grid-column:1 / -1 !important;justify-content:center !important;margin-top:1.25rem !important;}}";

  var normalizedPath = window.location.pathname.replace(/\/+$/, '') || '/';
  var isHomepage = normalizedPath === '/';

  if (!isHomepage) {
    document.querySelectorAll('.aku-media-arrow').forEach(function (arrow) {
      arrow.remove();
    });
    return;
  }

  Array.from(document.querySelectorAll('ul.blog__posts.slider, .blog__posts.slider')).forEach(function (slider) {
    if (!(slider instanceof HTMLElement)) return;

    var wrap = slider.parentElement;
    if (!wrap || !wrap.classList.contains('aku-media-slider-wrap')) {
      wrap = document.createElement('div');
      wrap.className = 'aku-media-slider-wrap';
      slider.parentNode.insertBefore(wrap, slider);
      wrap.appendChild(slider);
    }

    var prev = wrap.querySelector('.aku-media-arrow--prev');
    if (!prev) {
      prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'aku-media-arrow aku-media-arrow--prev';
      prev.setAttribute('aria-label', 'Scroll media left');
      prev.innerHTML = '&#8592;';
      wrap.appendChild(prev);
    }

    var next = wrap.querySelector('.aku-media-arrow--next');
    if (!next) {
      next = document.createElement('button');
      next.type = 'button';
      next.className = 'aku-media-arrow aku-media-arrow--next';
      next.setAttribute('aria-label', 'Scroll media right');
      next.innerHTML = '&#8594;';
      wrap.appendChild(next);
    }

    if (!slider.dataset.akuMediaArrowBound) {
      slider.dataset.akuMediaArrowBound = 'true';
      prev.addEventListener('click', function () {
        slider.scrollBy({ left: -Math.max(slider.clientWidth * 0.9, 260), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        slider.scrollBy({ left: Math.max(slider.clientWidth * 0.9, 260), behavior: 'smooth' });
      });
    }

    var updateArrowState = function () {
      var hasOverflow = slider.scrollWidth > slider.clientWidth + 12;
      var maxScrollLeft = Math.max(slider.scrollWidth - slider.clientWidth, 0);
      prev.hidden = !hasOverflow || slider.scrollLeft <= 8;
      next.hidden = !hasOverflow || slider.scrollLeft >= maxScrollLeft - 8;
    };

    if (!slider.dataset.akuMediaArrowScrollBound) {
      slider.dataset.akuMediaArrowScrollBound = 'true';
      slider.addEventListener('scroll', updateArrowState, { passive: true });
    }

    requestAnimationFrame(updateArrowState);
    window.addEventListener('resize', updateArrowState);
  });
}
enhanceHomepageMediaAndFooter();
if (!window.akuHomepageMediaBound) {
  window.akuHomepageMediaBound = true;
  document.addEventListener('DOMContentLoaded', enhanceHomepageMediaAndFooter);
  document.addEventListener('shopify:section:load', enhanceHomepageMediaAndFooter);
  window.addEventListener('load', enhanceHomepageMediaAndFooter, { once: true });
}
(function () {
  function akuRunHomepagePolish() {
    var styleTag = document.getElementById('aku-home-footer-layout-fix-3');
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'aku-home-footer-layout-fix-3';
      document.head.appendChild(styleTag);
    }
    styleTag.textContent = "#insta-feed.aku-insta-shell{position:relative;overflow:hidden;} #insta-feed .instafeed-new-layout-container{width:100% !important;overflow:hidden;} #insta-feed .instafeed-new-layout-wrapper.aku-insta-scroll{display:flex !important;grid-template-columns:none !important;overflow-x:auto !important;scroll-behavior:smooth;gap:15px !important;padding:0 46px;} #insta-feed .instafeed-new-layout-wrapper.aku-insta-scroll::-webkit-scrollbar{display:none;} #insta-feed .instafeed-new-layout-item{flex:0 0 auto;} .aku-insta-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:4;width:42px;height:42px;border-radius:999px;border:1px solid rgba(255,255,255,.35);background:rgba(15,15,15,.72);color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;} .aku-insta-arrow--prev{left:6px;} .aku-insta-arrow--next{right:6px;} .footer__payment{width:100% !important;display:flex !important;justify-content:center !important;text-align:center !important;} .footer__payment .list-payment{display:flex !important;justify-content:center !important;flex-wrap:wrap;gap:.8rem;margin:0 auto !important;padding-left:0 !important;} .aku-footer-top-row{display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:start;gap:2rem;width:100%;} .aku-footer-social-row{display:flex;justify-content:center;align-items:center;gap:1rem;flex-wrap:wrap;width:100%;margin-top:1rem;} .aku-footer-social-row .footer__list-social{display:flex !important;justify-content:center !important;width:auto !important;margin:0 !important;} .aku-footer-social-row .footer__follow-on-shop{margin:0 !important;} footer .desktop-localization-wrapper{margin:0 !important;justify-self:end;align-self:start;} .footer-block--newsletter{margin:0 !important;} .footer-block--newsletter .footer__list-social{display:none !important;} @media screen and (max-width: 989px){.aku-footer-top-row{grid-template-columns:1fr;}.aku-insta-arrow{width:36px;height:36px;}.aku-insta-arrow--prev{left:4px;}.aku-insta-arrow--next{right:4px;}}";
    var feed = document.getElementById('insta-feed');
    var wrap = feed && feed.querySelector('.instafeed-new-layout-wrapper');
    if (feed && wrap) {
      feed.classList.add('aku-insta-shell');
      wrap.classList.add('aku-insta-scroll');
      if (!feed.querySelector('.aku-insta-arrow--prev')) {
        var prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'aku-insta-arrow aku-insta-arrow--prev';
        prev.setAttribute('aria-label', 'Scroll media left');
        prev.innerHTML = '&#8592;';
        prev.addEventListener('click', function () { wrap.scrollBy({ left: -Math.max(wrap.clientWidth * 0.9, 260), behavior: 'smooth' }); });
        feed.appendChild(prev);
      }
      if (!feed.querySelector('.aku-insta-arrow--next')) {
        var next = document.createElement('button');
        next.type = 'button';
        next.className = 'aku-insta-arrow aku-insta-arrow--next';
        next.setAttribute('aria-label', 'Scroll media right');
        next.innerHTML = '&#8594;';
        next.addEventListener('click', function () { wrap.scrollBy({ left: Math.max(wrap.clientWidth * 0.9, 260), behavior: 'smooth' }); });
        feed.appendChild(next);
      }
    }
    var top = document.querySelector('footer .footer__content-top.page-width');
    var newsletter = top && top.querySelector('.footer-block--newsletter');
    var loc = top && top.querySelector('.desktop-localization-wrapper');
    var menu = top && top.querySelector('.footer__blocks-wrapper');
    var social = top && top.querySelector('.footer__list-social');
    var follow = top && top.querySelector('.footer__follow-on-shop');
    if (top && newsletter && loc) {
      var topRow = top.querySelector('.aku-footer-top-row');
      if (!topRow) { topRow = document.createElement('div'); topRow.className = 'aku-footer-top-row'; top.insertBefore(topRow, top.firstChild); }
      if (!topRow.contains(newsletter)) topRow.appendChild(newsletter);
      if (!topRow.contains(loc)) topRow.appendChild(loc);
      var socialRow = top.querySelector('.aku-footer-social-row');
      if (!socialRow) { socialRow = document.createElement('div'); socialRow.className = 'aku-footer-social-row'; if (topRow.nextSibling) { top.insertBefore(socialRow, topRow.nextSibling); } else { top.appendChild(socialRow); } }
      if (follow && !socialRow.contains(follow)) socialRow.appendChild(follow);
      if (social && !socialRow.contains(social)) socialRow.appendChild(social);
      if (menu && menu.parentElement !== top) top.appendChild(menu);
    }
  }
  akuRunHomepagePolish();
  setTimeout(akuRunHomepagePolish, 400);
  setTimeout(akuRunHomepagePolish, 1500);
  setTimeout(akuRunHomepagePolish, 3200);
})();
(function () {
  function akuFooterRowAdjust() {
    var styleTag = document.getElementById('aku-home-footer-layout-fix-4');
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'aku-home-footer-layout-fix-4';
      document.head.appendChild(styleTag);
    }
    styleTag.textContent = ".aku-footer-top-row{display:block !important;} .aku-footer-social-row{display:flex;justify-content:center;align-items:center;gap:1rem;flex-wrap:wrap;width:100%;margin-top:1rem;} footer .desktop-localization-wrapper{display:flex !important;justify-content:flex-end !important;width:100% !important;margin-top:1rem !important;} .footer__payment{width:100% !important;display:flex !important;justify-content:center !important;align-items:center !important;text-align:center !important;margin-top:1.5rem !important;} .footer__payment .list-payment{display:flex !important;justify-content:center !important;align-items:center !important;flex-wrap:wrap;gap:.8rem;margin:0 auto !important;padding-left:0 !important;} .footer__bottom,.footer__content-bottom{display:flex !important;justify-content:center !important;} @media screen and (min-width: 990px){.aku-footer-top-row{display:block !important;} footer .desktop-localization-wrapper{justify-content:flex-end !important;}}";
    var top = document.querySelector('footer .footer__content-top.page-width');
    var newsletter = top && top.querySelector('.footer-block--newsletter');
    var loc = top && top.querySelector('.desktop-localization-wrapper');
    var menu = top && top.querySelector('.footer__blocks-wrapper');
    var social = top && top.querySelector('.footer__list-social');
    var follow = top && top.querySelector('.footer__follow-on-shop');
    if (top && newsletter) {
      var topRow = top.querySelector('.aku-footer-top-row');
      if (!topRow) { topRow = document.createElement('div'); topRow.className = 'aku-footer-top-row'; top.insertBefore(topRow, top.firstChild); }
      if (!topRow.contains(newsletter)) topRow.appendChild(newsletter);
      var socialRow = top.querySelector('.aku-footer-social-row');
      if (!socialRow) { socialRow = document.createElement('div'); socialRow.className = 'aku-footer-social-row'; if (topRow.nextSibling) { top.insertBefore(socialRow, topRow.nextSibling); } else { top.appendChild(socialRow); } }
      if (follow && !socialRow.contains(follow)) socialRow.appendChild(follow);
      if (social && !socialRow.contains(social)) socialRow.appendChild(social);
      if (loc && loc.parentElement !== top) top.appendChild(loc);
      if (menu && menu.parentElement !== top) top.appendChild(menu);
    }
  }
  akuFooterRowAdjust();
  setTimeout(akuFooterRowAdjust, 400);
  setTimeout(akuFooterRowAdjust, 1500);
})();
(function () {
  function akuFooterLayoutRow() {
    var styleTag = document.getElementById('aku-home-footer-layout-fix-5');
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'aku-home-footer-layout-fix-5';
      document.head.appendChild(styleTag);
    }
    styleTag.textContent = ".aku-footer-main-row{display:grid;grid-template-columns:minmax(0,1fr) auto minmax(0,1fr);align-items:center;column-gap:2rem;row-gap:1rem;width:100%;} .aku-footer-main-row .footer-block--newsletter{grid-column:1;justify-self:start;margin:0 !important;display:flex !important;flex-direction:column !important;align-items:flex-start !important;max-width:360px;} .aku-footer-main-row .aku-footer-social-row{grid-column:2;justify-self:center;display:flex;align-items:center;justify-content:center;gap:1rem;flex-wrap:wrap;} .aku-footer-main-row .desktop-localization-wrapper{grid-column:3;justify-self:end;display:flex !important;justify-content:flex-end !important;width:auto !important;margin:0 !important;} .aku-footer-social-row .footer__list-social{display:flex !important;justify-content:center !important;align-items:center !important;gap:1rem;width:auto !important;margin:0 !important;padding-left:0 !important;} .aku-footer-social-row .footer__follow-on-shop{margin:0 !important;} .footer__payment{width:100% !important;display:flex !important;justify-content:center !important;align-items:center !important;text-align:center !important;margin-top:1.5rem !important;} .footer__payment .list-payment{display:grid !important;grid-template-columns:repeat(9, max-content);justify-content:center !important;align-items:center !important;column-gap:.8rem;row-gap:.8rem;margin:0 auto !important;padding-left:0 !important;width:auto !important;} .footer__content-bottom,.footer__bottom{display:flex !important;justify-content:center !important;} @media screen and (max-width: 989px){.aku-footer-main-row{grid-template-columns:1fr;}.aku-footer-main-row .footer-block--newsletter,.aku-footer-main-row .aku-footer-social-row,.aku-footer-main-row .desktop-localization-wrapper{grid-column:auto;justify-self:center;}.aku-footer-main-row .footer-block--newsletter{align-items:center !important;}.footer__payment .list-payment{grid-template-columns:repeat(4, max-content);}}";
    var top = document.querySelector('footer .footer__content-top.page-width');
    var newsletter = top && top.querySelector('.footer-block--newsletter');
    var loc = top && top.querySelector('.desktop-localization-wrapper');
    var menu = top && top.querySelector('.footer__blocks-wrapper');
    var social = top && top.querySelector('.footer__list-social');
    var follow = top && top.querySelector('.footer__follow-on-shop');
    if (top && newsletter && loc) {
      var mainRow = top.querySelector('.aku-footer-main-row');
      if (!mainRow) { mainRow = document.createElement('div'); mainRow.className = 'aku-footer-main-row'; top.insertBefore(mainRow, top.firstChild); }
      if (!mainRow.contains(newsletter)) mainRow.appendChild(newsletter);
      var socialRow = top.querySelector('.aku-footer-social-row');
      if (!socialRow) { socialRow = document.createElement('div'); socialRow.className = 'aku-footer-social-row'; }
      if (follow && !socialRow.contains(follow)) socialRow.appendChild(follow);
      if (social && !socialRow.contains(social)) socialRow.appendChild(social);
      if (!mainRow.contains(socialRow)) mainRow.appendChild(socialRow);
      if (!mainRow.contains(loc)) mainRow.appendChild(loc);
      if (menu && menu.parentElement !== top) top.appendChild(menu);
    }
  }
  akuFooterLayoutRow();
  setTimeout(akuFooterLayoutRow, 400);
  setTimeout(akuFooterLayoutRow, 1500);
})();
(function () {
  function akuFooterAlignmentTighten() {
    var styleTag = document.getElementById('aku-home-footer-layout-fix-6');
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'aku-home-footer-layout-fix-6';
      document.head.appendChild(styleTag);
    }
    styleTag.textContent = ".aku-footer-main-row{display:grid !important;grid-template-columns:minmax(260px,1fr) auto minmax(260px,1fr) !important;align-items:center !important;column-gap:1.25rem !important;row-gap:0 !important;width:100% !important;} .aku-footer-main-row .footer-block--newsletter{grid-column:1 !important;justify-self:start !important;align-self:center !important;display:flex !important;flex-direction:column !important;align-items:flex-start !important;max-width:320px !important;width:100% !important;margin:0 !important;} .aku-footer-main-row .aku-footer-social-row{grid-column:2 !important;justify-self:center !important;display:flex !important;align-items:center !important;justify-content:center !important;gap:1rem !important;flex-wrap:nowrap !important;white-space:nowrap !important;margin:0 !important;} .aku-footer-main-row .desktop-localization-wrapper{grid-column:3 !important;justify-self:end !important;align-self:center !important;display:flex !important;justify-content:flex-end !important;width:auto !important;margin:0 !important;} .aku-footer-social-row .footer__list-social{display:flex !important;justify-content:center !important;align-items:center !important;gap:1rem !important;flex-wrap:nowrap !important;width:auto !important;margin:0 !important;padding-left:0 !important;} .aku-footer-social-row .footer__follow-on-shop{margin:0 !important;flex:0 0 auto !important;} .footer__payment{width:100% !important;max-width:none !important;display:flex !important;justify-content:center !important;align-items:center !important;text-align:center !important;margin:1.5rem auto 0 !important;padding:0 !important;} .footer__payment .list-payment{display:grid !important;grid-template-columns:repeat(9, max-content) !important;justify-content:center !important;align-items:center !important;column-gap:.8rem !important;row-gap:.8rem !important;margin:0 auto !important;padding-left:0 !important;width:max-content !important;max-width:none !important;} .footer__content-bottom,.footer__bottom{display:flex !important;justify-content:center !important;width:100% !important;} @media screen and (max-width: 989px){.aku-footer-main-row{grid-template-columns:1fr !important;row-gap:1rem !important;}.aku-footer-main-row .footer-block--newsletter,.aku-footer-main-row .aku-footer-social-row,.aku-footer-main-row .desktop-localization-wrapper{grid-column:auto !important;justify-self:center !important;}.aku-footer-main-row .footer-block--newsletter{align-items:center !important;}.aku-footer-social-row{flex-wrap:wrap !important;}.footer__payment .list-payment{grid-template-columns:repeat(4, max-content) !important;}}";
    var top = document.querySelector('footer .footer__content-top.page-width');
    var newsletter = top && top.querySelector('.footer-block--newsletter');
    var loc = top && top.querySelector('.desktop-localization-wrapper');
    var menu = top && top.querySelector('.footer__blocks-wrapper');
    var social = top && top.querySelector('.footer__list-social');
    var follow = top && top.querySelector('.footer__follow-on-shop');
    if (top && newsletter && loc) {
      var mainRow = top.querySelector('.aku-footer-main-row');
      if (!mainRow) { mainRow = document.createElement('div'); mainRow.className = 'aku-footer-main-row'; top.insertBefore(mainRow, top.firstChild); }
      if (!mainRow.contains(newsletter)) mainRow.appendChild(newsletter);
      var socialRow = top.querySelector('.aku-footer-social-row');
      if (!socialRow) { socialRow = document.createElement('div'); socialRow.className = 'aku-footer-social-row'; }
      if (follow && !socialRow.contains(follow)) socialRow.appendChild(follow);
      if (social && !socialRow.contains(social)) socialRow.appendChild(social);
      if (!mainRow.contains(socialRow)) mainRow.appendChild(socialRow);
      if (!mainRow.contains(loc)) mainRow.appendChild(loc);
      if (menu && menu.parentElement !== top) top.appendChild(menu);
    }
  }
  akuFooterAlignmentTighten();
  setTimeout(akuFooterAlignmentTighten, 400);
  setTimeout(akuFooterAlignmentTighten, 1500);
})();
(function () {
  function akuFooterFinalAlign() {
    var styleTag = document.getElementById('aku-home-footer-layout-fix-7');
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'aku-home-footer-layout-fix-7';
      document.head.appendChild(styleTag);
    }
    styleTag.textContent = ".aku-footer-main-row{display:grid !important;grid-template-columns:minmax(280px,1fr) auto minmax(220px,1fr) !important;align-items:center !important;column-gap:1.25rem !important;row-gap:0 !important;width:100% !important;} .aku-footer-main-row .footer-block--newsletter{grid-column:1 !important;justify-self:start !important;align-self:center !important;display:flex !important;flex-direction:row !important;align-items:center !important;gap:1rem !important;max-width:none !important;width:100% !important;margin:0 !important;} .aku-footer-main-row .footer-block__newsletter{display:flex !important;flex-direction:row !important;align-items:center !important;gap:1rem !important;width:100% !important;} .aku-footer-main-row .footer-block__heading{margin:0 !important;white-space:nowrap !important;flex:0 0 auto !important;} .aku-footer-main-row .footer__newsletter{margin:0 !important;flex:1 1 auto !important;max-width:280px !important;} .aku-footer-main-row .newsletter-form__field-wrapper{width:100% !important;} .aku-footer-main-row .aku-footer-social-row{grid-column:2 !important;justify-self:center !important;display:flex !important;align-items:center !important;justify-content:center !important;gap:1rem !important;flex-wrap:nowrap !important;white-space:nowrap !important;margin:0 !important;} .aku-footer-main-row .desktop-localization-wrapper{grid-column:3 !important;justify-self:end !important;align-self:center !important;display:flex !important;justify-content:flex-end !important;width:auto !important;margin:0 !important;} .aku-footer-social-row .footer__list-social{display:flex !important;justify-content:center !important;align-items:center !important;gap:1rem !important;flex-wrap:nowrap !important;width:auto !important;margin:0 !important;padding-left:0 !important;} .aku-footer-social-row .footer__follow-on-shop{margin:0 !important;flex:0 0 auto !important;} .footer__payment{width:100vw !important;max-width:none !important;position:relative !important;left:50% !important;transform:translateX(-50%) !important;display:flex !important;justify-content:center !important;align-items:center !important;text-align:center !important;margin:1.5rem 0 0 !important;padding:0 !important;} .footer__payment .list-payment{display:grid !important;grid-template-columns:repeat(9, max-content) !important;justify-content:center !important;justify-items:center !important;align-items:center !important;place-content:center !important;column-gap:.8rem !important;row-gap:.8rem !important;margin:0 auto !important;padding-left:0 !important;width:max-content !important;max-width:none !important;} .footer__content-bottom,.footer__bottom{display:flex !important;justify-content:center !important;width:100% !important;} @media screen and (max-width: 989px){.aku-footer-main-row{grid-template-columns:1fr !important;row-gap:1rem !important;}.aku-footer-main-row .footer-block--newsletter,.aku-footer-main-row .aku-footer-social-row,.aku-footer-main-row .desktop-localization-wrapper{grid-column:auto !important;justify-self:center !important;}.aku-footer-main-row .footer-block--newsletter,.aku-footer-main-row .footer-block__newsletter{flex-direction:column !important;align-items:center !important;}.aku-footer-main-row .footer__newsletter{max-width:320px !important;}.aku-footer-social-row{flex-wrap:wrap !important;}.footer__payment{left:0 !important;transform:none !important;width:100% !important;}.footer__payment .list-payment{grid-template-columns:repeat(4, max-content) !important;}}";
  }
  akuFooterFinalAlign();
  setTimeout(akuFooterFinalAlign, 400);
  setTimeout(akuFooterFinalAlign, 1500);
})();
(function () {
  function akuResetFooterLayout() {
    var footer = document.querySelector('footer');
    var top = footer && footer.querySelector('.footer__content-top.page-width');
    var payment = footer && footer.querySelector('.footer__payment');
    if (!top) return;

    ['aku-footer-clean-layout-v5', 'aku-footer-clean-layout-v4', 'aku-footer-clean-layout-v3', 'aku-footer-clean-layout-v2'].forEach(function (id) {
      var oldStyle = document.getElementById(id);
      if (oldStyle) oldStyle.remove();
    });

    var styleId = 'aku-footer-clean-layout-v6';
    var styleTag = document.getElementById(styleId);
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = styleId;
      styleTag.textContent = [
        "footer .footer__content-top.page-width { display:flex !important; flex-direction:column !important; align-items:center !important; gap:18px !important; text-align:center !important; }",
        "footer .aku-footer-stack { width:100% !important; max-width:720px !important; display:flex !important; flex-direction:column !important; align-items:center !important; gap:18px !important; }",
        "footer .aku-footer-signup { width:100% !important; max-width:520px !important; }",
        "footer .aku-footer-signup-label { display:block !important; margin:0 0 10px !important; font-size:13px !important; font-weight:700 !important; letter-spacing:0.08em !important; text-transform:uppercase !important; line-height:1.2 !important; }",
        "footer .aku-footer-signup-fields { display:flex !important; align-items:center !important; gap:10px !important; }",
        "footer .aku-footer-signup input[type=email] { flex:1 1 auto !important; min-width:0 !important; height:46px !important; padding:0 14px !important; border:1px solid rgba(18,18,18,0.18) !important; background:#fff !important; color:#121212 !important; }",
        "footer .aku-footer-signup button { height:46px !important; padding:0 18px !important; border:1px solid #121212 !important; background:#121212 !important; color:#fff !important; text-transform:uppercase !important; letter-spacing:0.08em !important; }",
        "footer .aku-footer-social { display:flex !important; align-items:center !important; justify-content:center !important; gap:22px !important; flex-wrap:wrap !important; }",
        "footer .aku-footer-social a, footer .aku-footer-legal a { color:inherit !important; text-decoration:none !important; }",
        "footer .aku-footer-social a { font-size:13px !important; font-weight:700 !important; letter-spacing:0.08em !important; text-transform:uppercase !important; }",
        "footer .aku-footer-legal { display:flex !important; align-items:center !important; justify-content:center !important; gap:18px !important; flex-wrap:wrap !important; font-size:12px !important; letter-spacing:0.06em !important; text-transform:uppercase !important; }",
        "footer .aku-footer-currency { display:flex !important; justify-content:center !important; }",
        "footer .aku-footer-currency .localization-form__select { justify-content:center !important; }",
        "footer .footer__content-bottom { width:100% !important; } footer .footer__content-bottom-wrapper.page-width { width:100% !important; max-width:100% !important; box-sizing:border-box !important; margin:0 auto !important; padding-left:0 !important; padding-right:0 !important; justify-content:center !important; } footer .footer__column.footer__column--info { width:100% !important; max-width:100% !important; flex:0 0 100% !important; align-items:center !important; } footer .footer__payment { width:100% !important; max-width:100% !important; display:block !important; text-align:center !important; margin-top:8px !important; }",
        "footer .footer__payment .list-payment { width:100% !important; max-width:100% !important; margin:0 auto !important; padding:0 !important; display:grid !important; grid-template-columns:repeat(20, 34px) !important; justify-content:center !important; gap:8px 4px !important; }",
        "footer .footer__payment .list-payment__item { width:34px !important; display:flex !important; justify-content:center !important; } footer .footer__payment .list-payment__item svg { width:34px !important; height:22px !important; }",
        "@media screen and (max-width: 989px) { footer .aku-footer-stack { max-width:560px !important; } footer .footer__payment .list-payment { grid-template-columns:repeat(20, 34px) !important; gap:8px 4px !important; } }",
        "@media screen and (max-width: 640px) { footer .aku-footer-signup-fields { flex-direction:column !important; align-items:stretch !important; } footer .aku-footer-signup button { width:100% !important; } footer .footer__payment .list-payment { grid-template-columns:repeat(10, 34px) !important; gap:8px 4px !important; } }",
        "footer .aku-footer-signup-label, footer .aku-footer-social a { font-weight:700 !important; }"
      ].join('');
      document.head.appendChild(styleTag);
    }

    var localization = top.querySelector('.aku-footer-currency .desktop-localization-wrapper') || top.querySelector('.desktop-localization-wrapper');
    if (localization && localization.closest('.aku-footer-stack')) {
      top.insertBefore(localization, top.firstChild);
    }

    top.querySelectorAll('[class*="aku-footer"]').forEach(function (node) {
      if (localization && node.contains(localization)) return;
      node.remove();
    });
    top.querySelectorAll('.footer__blocks-wrapper, .footer__follow-on-shop, .footer__list-social, .footer-block--newsletter').forEach(function (node) {
      node.remove();
    });

    var stack = document.createElement('div');
    stack.className = 'aku-footer-stack';

    var signupWrap = document.createElement('div');
    signupWrap.className = 'aku-footer-signup';
    if (window.location.pathname.indexOf('/challenge') === 0) {
      signupWrap.innerHTML = '' +
        '<div class="aku-footer-signup-challenge-note">' +
        '<p class="aku-footer-signup-label"><span style="font-weight:700;">Join the community</span></p>' +
        '<p class="aku-footer-signup-status">Complete the security check above to finish joining.</p>' +
        '</div>';
    } else {
      signupWrap.innerHTML = '' +
        '<form method="post" action="/contact#ContactFooter" accept-charset="UTF-8">' +
        '<input type="hidden" name="form_type" value="customer">' +
        '<input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="contact[tags]" value="newsletter">' +
        '<label class="aku-footer-signup-label" for="AkuFooterEmail"><span style="font-weight:700;">Join the community</span></label>' +
        '<div class="aku-footer-signup-fields">' +
        '<input id="AkuFooterEmail" type="email" name="contact[email]" placeholder="Email address" autocorrect="off" autocapitalize="off" autocomplete="email" required>' +
        '<button type="submit">Join</button>' +
        '</div>' +
        '</form>';
    }
    var signupLabel = signupWrap.querySelector('.aku-footer-signup-label');
    if (signupLabel) signupLabel.style.fontWeight = '700';

    var socialWrap = document.createElement('div');
    socialWrap.className = 'aku-footer-social';
    socialWrap.innerHTML = '<a href="https://www.instagram.com/akupasal" target="_blank" rel="noopener"><span style="font-weight:700;">Instagram</span></a><a href="https://www.tiktok.com/@akupasal" target="_blank" rel="noopener"><span style="font-weight:700;">TikTok</span></a><a href="https://uk.pinterest.com/akupasal/" target="_blank" rel="noopener"><span style="font-weight:700;">Pinterest</span></a><a href="https://shop.app/m/h4dxkz1jy5" target="_blank" rel="noopener"><span style="font-weight:700;">Shop App</span></a>';
    socialWrap.querySelectorAll('a').forEach(function (link) { link.style.fontWeight = '700'; });

    var legalWrap = document.createElement('div');
    legalWrap.className = 'aku-footer-legal';
    legalWrap.innerHTML = [
      '<a href="/policies/terms-of-service">Terms</a>',
      '<a href="/policies/privacy-policy">Privacy</a>',
      '<a href="/policies/refund-policy">Refunds</a>',
      '<a href="/policies/shipping-policy">Shipping</a>'
    ].join('');

    stack.appendChild(signupWrap);
    stack.appendChild(socialWrap);
    stack.appendChild(legalWrap);

    if (localization) {
      var currencyWrap = document.createElement('div');
      currencyWrap.className = 'aku-footer-currency';
      currencyWrap.appendChild(localization);
      stack.appendChild(currencyWrap);
    }

    top.appendChild(stack);

    var bottomWrap = footer && footer.querySelector('.footer__content-bottom-wrapper.page-width');
    var infoColumn = footer && footer.querySelector('.footer__column.footer__column--info');
    if (bottomWrap) {
      bottomWrap.style.width = '100%';
      bottomWrap.style.maxWidth = '100%';
      bottomWrap.style.margin = '0 auto';
      bottomWrap.style.paddingLeft = '0';
      bottomWrap.style.paddingRight = '0';
      bottomWrap.style.justifyContent = 'center';
      bottomWrap.style.display = 'flex';
    }
    if (infoColumn) {
      infoColumn.style.width = '100%';
      infoColumn.style.maxWidth = '100%';
      infoColumn.style.flex = '0 0 100%';
      infoColumn.style.alignItems = 'center';
      infoColumn.style.justifyContent = 'center';
    }
    if (payment) {
      payment.style.width = '100%';
      payment.style.maxWidth = '100%';
      payment.style.display = 'block';
      payment.style.textAlign = 'center';
      var list = payment.querySelector('.list-payment');
      if (list) {
        list.style.width = '100%';
        list.style.maxWidth = '100%';
        list.style.position = 'static';
        list.style.left = 'auto';
        list.style.transform = 'none';
      }
    }
  }
  akuResetFooterLayout();
  if (!window.akuFooterLayoutBound) {
    window.akuFooterLayoutBound = true;
    window.addEventListener('load', akuResetFooterLayout, { once: true });
    window.addEventListener('resize', function () {
      clearTimeout(window.akuFooterLayoutResizeTimer);
      window.akuFooterLayoutResizeTimer = setTimeout(akuResetFooterLayout, 120);
    });
    document.addEventListener('shopify:section:load', akuResetFooterLayout);
  }
})();

(function () {
  function akuFixSearchModal() {
    var styleId = 'aku-search-modal-fix';
    var styleTag = document.getElementById(styleId);
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = styleId;
      styleTag.textContent = [
        ".search-modal__form .field{display:flex !important;align-items:center !important;min-height:5.2rem !important;border-bottom:1px solid rgba(18,18,18,0.18) !important;}",
        ".search-modal__form .field__label{display:none !important;}",
        ".search-modal__form .search__input{padding:1.2rem 9rem 1.2rem 0 !important;background:transparent !important;border:0 !important;box-shadow:none !important;}",
        ".search-modal__form .reset__button,.search-modal__form .search__button{top:50% !important;transform:translateY(-50%) !important;}",
        ".predictive-search__search-for-button,#predictive-search-results-queries-list,#predictive-search-queries{display:none !important;}",
        ".predictive-search__results-groups-wrapper{display:block !important;}"
      ].join('');
      document.head.appendChild(styleTag);
    }

    document.querySelectorAll('form[action="/search"]').forEach(function (form) {
      var typeInput = form.querySelector('input[name="type"]');
      if (!typeInput) {
        typeInput = document.createElement('input');
        typeInput.type = 'hidden';
        typeInput.name = 'type';
        form.appendChild(typeInput);
      }
      typeInput.value = 'product';
    });
  }
  akuFixSearchModal();
  setTimeout(akuFixSearchModal, 300);
  setTimeout(akuFixSearchModal, 1200);
})();


(function () {
  function akuBuildMobileUtilityLinks() {
    var accountHref = '/customer_authentication/login';
    var existingAccount = document.querySelector('a[href*="customer_authentication/login"], a[href*="customer_authentication"], a.header__icon--account, a[href*="/account"]');
    if (existingAccount && existingAccount.getAttribute('href')) {
      accountHref = existingAccount.getAttribute('href');
    }

    document.querySelectorAll('.menu-drawer, details-menu-drawer').forEach(function (drawerRoot) {
      var nav = drawerRoot.querySelector('.menu-drawer__menu') || drawerRoot.querySelector('.menu-drawer__navigation');
      if (!nav) return;

      var utilityWrap = drawerRoot.querySelector('.aku-mobile-utility-links');
      if (!utilityWrap) {
        utilityWrap = document.createElement('div');
        utilityWrap.className = 'aku-mobile-utility-links';
        utilityWrap.innerHTML = [
          '<a class="menu-drawer__menu-item list-menu__item link link--text focus-inset" href="/search">Search</a>',
          '<a class="menu-drawer__menu-item list-menu__item link link--text focus-inset aku-mobile-account-link" href="' + accountHref + '">Account</a>'
        ].join('');
        nav.parentNode.insertBefore(utilityWrap, nav.nextSibling);
      } else {
        var accountLink = utilityWrap.querySelector('.aku-mobile-account-link');
        if (accountLink) accountLink.setAttribute('href', accountHref);
      }
    });
  }

  function akuEnhanceFooterSignup() {
    var signupSuccess = false;
    try {
      var currentUrl = new URL(window.location.href);
      signupSuccess = currentUrl.searchParams.get('customer_posted') === 'true';
    } catch (error) {
      signupSuccess = window.location.search.indexOf('customer_posted=true') !== -1;
    }

    document.querySelectorAll('.aku-footer-signup form').forEach(function (form) {
      if (form.dataset.akuSignupBound === 'true') return;
      form.dataset.akuSignupBound = 'true';

      var submitButton = form.querySelector('button[type="submit"]');
      var status = form.querySelector('.aku-footer-signup-status');
      if (!status) {
        status = document.createElement('p');
        status.className = 'aku-footer-signup-status';
        status.setAttribute('aria-live', 'polite');
        form.appendChild(status);
      }

      if (signupSuccess) {
        status.textContent = 'Welcome to the community.';
        form.classList.add('is-success');
      }

      form.addEventListener('submit', function () {
        if (submitButton) {
          submitButton.textContent = 'Joining...';
        }
        status.textContent = 'Joining the community...';
        form.classList.remove('is-success');

        window.setTimeout(function () {
          if (form.classList.contains('is-success')) return;
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = 'Join';
          }
          if (status.textContent === 'Joining the community...') {
            status.textContent = '';
          }
        }, 8000);
      });
    });
  }

  function akuAutoSubmitChallengeSignup() {
    if (window.location.pathname.indexOf('/challenge') !== 0) return;
    if (document.documentElement.dataset.akuChallengeWatcher === 'true') return;
    document.documentElement.dataset.akuChallengeWatcher = 'true';

    var documentObserver;
    var poller;

    function findChallengeForm() {
      return document.getElementById('captcha_form') || document.querySelector('form[data-nocaptcha="true"][action*="/contact"]');
    }

    function bindChallengeForm(form) {
      if (!form || form.dataset.akuChallengeBound === 'true') return;
      form.dataset.akuChallengeBound = 'true';

      var submitted = false;
      var submitTimer;
      var status = document.querySelector('.aku-footer-signup-status');
      if (!status) {
        status = document.createElement('p');
        status.className = 'aku-footer-signup-status';
        status.setAttribute('aria-live', 'polite');
        form.appendChild(status);
      }

      function getCaptchaToken() {
        var tokenInput = form.querySelector('textarea[name=\"h-captcha-response\"], input[name=\"h-captcha-response\"], textarea[name=\"g-recaptcha-response\"], input[name=\"g-recaptcha-response\"]');
        if (tokenInput && tokenInput.value) return tokenInput.value;

        var iframe = form.querySelector('iframe[data-hcaptcha-response]') || document.querySelector('iframe[data-hcaptcha-response]');
        if (iframe) return iframe.getAttribute('data-hcaptcha-response') || '';

        return '';
      }

      function finishSubmit() {
        var submitControl = form.querySelector('button[type=\"submit\"], input[type=\"submit\"]');
        if (submitControl && typeof submitControl.click === 'function') {
          submitControl.click();
          return;
        }

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
          return;
        }

        form.submit();
      }

      function submitChallengeForm() {
        if (submitted) return;

        var token = getCaptchaToken();
        if (!token) return;

        submitted = true;
        form.classList.add('is-submitting');
        status.textContent = 'Joining the community...';

        submitTimer = window.setTimeout(finishSubmit, 700);
      }

      submitChallengeForm();

      var formObserver = new MutationObserver(submitChallengeForm);
      formObserver.observe(form, { attributes: true, childList: true, subtree: true });

      poller = window.setInterval(submitChallengeForm, 400);
    }

    function connect() {
      var form = findChallengeForm();
      if (form) {
        bindChallengeForm(form);
        return true;
      }
      return false;
    }

    if (connect()) return;

    documentObserver = new MutationObserver(connect);
    documentObserver.observe(document.documentElement, { childList: true, subtree: true, attributes: true });

    poller = window.setInterval(connect, 400);
  }

  function akuRunMobileHeaderAndSignupEnhancements() {
    akuBuildMobileUtilityLinks();
    akuEnhanceFooterSignup();
    akuAutoSubmitChallengeSignup();
  }

  akuRunMobileHeaderAndSignupEnhancements();
  document.addEventListener('DOMContentLoaded', akuRunMobileHeaderAndSignupEnhancements);
  document.addEventListener('shopify:section:load', akuRunMobileHeaderAndSignupEnhancements);
  window.addEventListener('load', akuRunMobileHeaderAndSignupEnhancements, { once: true });
})();


(function () {
  var warmedAccountTargets = false;

  function warmCustomerAccountRoute() {
    if (warmedAccountTargets) return;
    warmedAccountTargets = true;

    ['https://shopify.com', 'https://cdn.shopify.com'].forEach(function (href) {
      var existing = document.querySelector('link[rel="preconnect"][href="' + href + '"]');
      if (existing) return;
      var link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });

    ['//shopify.com', '//cdn.shopify.com'].forEach(function (href) {
      if (document.querySelector('link[rel="dns-prefetch"][href="' + href + '"]')) return;
      var link = document.createElement('link');
      link.rel = 'dns-prefetch';
      link.href = href;
      document.head.appendChild(link);
    });
  }

  function bindCustomerAccountWarmup() {
    var accountLinks = Array.from(document.querySelectorAll('a.header__icon--account, a[href*="customer_authentication"], a[href*="/account"]'));
    if (!accountLinks.length) return;

    accountLinks.forEach(function (link) {
      if (link.dataset.akuAccountWarmupBound === 'true') return;
      link.dataset.akuAccountWarmupBound = 'true';
      ['pointerenter', 'touchstart', 'focus', 'mousedown'].forEach(function (eventName) {
        link.addEventListener(eventName, warmCustomerAccountRoute, { passive: true, once: true });
      });
    });
  }

  bindCustomerAccountWarmup();
  document.addEventListener('DOMContentLoaded', bindCustomerAccountWarmup);
  document.addEventListener('shopify:section:load', bindCustomerAccountWarmup);
window.addEventListener('load', warmCustomerAccountRoute, { once: true });
})();

(function () {
  function akuCenterFooterPayments() {
    var styleId = 'aku-footer-payment-center-fix';
    var styleTag = document.getElementById(styleId);
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = styleId;
      document.head.appendChild(styleTag);
    }

    styleTag.textContent = [
      "footer .footer__content-bottom{display:block !important;width:100% !important;}footer .footer__content-bottom-wrapper.page-width{display:block !important;width:100% !important;max-width:100% !important;margin:0 auto !important;padding-inline:0 !important;box-sizing:border-box !important;}footer .footer__column.footer__column--info{display:flex !important;width:100% !important;max-width:100% !important;justify-content:center !important;align-items:center !important;padding-inline:1.6rem !important;box-sizing:border-box !important;}footer .footer__payment{width:100% !important;max-width:100% !important;margin:1.5rem auto 0 !important;padding-inline:1.6rem !important;box-sizing:border-box !important;text-align:center !important;}",
      "footer .footer__payment .list-payment{display:flex !important;flex-wrap:wrap !important;justify-content:center !important;align-items:center !important;gap:.9rem 1rem !important;width:min(100%,68rem) !important;max-width:min(100%,68rem) !important;margin:0 auto !important;padding:0 !important;box-sizing:border-box !important;}",
      "footer .footer__payment .list-payment__item{display:flex !important;justify-content:center !important;align-items:center !important;min-width:0 !important;width:auto !important;padding:0 !important;}",
      "footer .footer__payment .list-payment__item svg{display:block !important;max-width:100% !important;height:auto !important;}",
      "@media screen and (max-width: 989px){footer .footer__payment{padding-inline:1.8rem !important;}footer .footer__payment .list-payment{width:min(100%,32rem) !important;max-width:min(100%,32rem) !important;gap:.8rem !important;}}",
      "@media screen and (max-width: 640px){footer .footer__payment{padding-inline:2rem !important;}footer .footer__payment .list-payment{width:min(100%,28rem) !important;max-width:min(100%,28rem) !important;gap:.8rem .7rem !important;}}"
    ].join('');
  }

  akuCenterFooterPayments();
  document.addEventListener('DOMContentLoaded', akuCenterFooterPayments);
  document.addEventListener('shopify:section:load', akuCenterFooterPayments);
  window.addEventListener('load', akuCenterFooterPayments, { once: true });
})();
